module.exports = {
      id: "icon-facebook-usage",
      viewBox: "0 0 13.521 25.459",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }